import { JiraIssuesConfigModalWithWrappers } from './JiraIssuesConfigModalWithWrappers';

export const JIRA_LIST_OF_LINKS_DATASOURCE_ID = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

export default JiraIssuesConfigModalWithWrappers;
